import { render } from "./famousList.vue?vue&type=template&id=25ba4ee8&scoped=true"
import script from "./famousList.vue?vue&type=script&lang=js"
export * from "./famousList.vue?vue&type=script&lang=js"

import "./famousList.vue?vue&type=style&index=0&id=25ba4ee8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ba4ee8"]])

export default __exports__